<template>
  <div>
    <FastTrackModal @launchEmbeddedApplication="launchEmbeddedApplication()"></FastTrackModal>
    <div id="fastTrackCTA" class="fast-track-cta-wrapper" :class="{ 'fast-track-hide': !fastTrackCTAVisible, 'fast-track-mb-2': Boolean(smallMarginBottom) }">
      <NuxtImg width="93px" src="/images/lendio-fast-track-dark-logo.svg" alt=""/>
      <h4 class="fast-track-cta-subheader mt-4">Fast-track application</h4>
      <ul class="fast-track-cta-bullet-list mb-4">
        <li class="fast-track-cta-bullet-point">Options as fast as 5 minutes</li>
        <li class="fast-track-cta-bullet-point">Easy, quick confirmation of business information</li>
      </ul>
      <button class="fast-track-btn-start btn mx-auto btn-primary" @click="launchEmbeddedApplication()">
        <span class="fast-track-btn-start-text">Continue with FastTrack</span>
      </button>
    </div>
  </div>
</template>

<script>
import FastTrackModal from './FastTrackModal'
import { useBorrowerStore } from '~/store/borrower'
import { useRootStore } from '~/store/root'
import { mapState, mapActions } from 'pinia'

export default {
  name: 'FastTrackCTA',
  props: ['forceOpen', 'smallMarginBottom'],
  data() {
    return {
      fastTrackUser: false,
      showFastTrack: false,
    }
  },
  mounted() {
    this.checkEmbeddedUser();
  },
  computed: {
    ...mapState(useRootStore, ['authUser', 'canUseEmbedded']),
    ...mapState(useBorrowerStore, {
      isTestBorrower: (store) => store.borrower.isTest,
      forceFastTrackCTA: (store) => store.forceFastTrackCTA,
      fastTrackModalVisible: (store) => store.fastTrackModalVisible
    }),

    fastTrackCTAVisible() {
      return (this.showFastTrack || this.forceFastTrackCTA) && !this.fastTrackModalVisible
    },
  },
  methods: {
    ...mapActions(useBorrowerStore, ['toggleFastTrackModalVisibility']),
    checkEmbeddedUser (attempts = 5, ms = 500) {
      if (!attempts) return

      if (process.client && window.lendio && window.lendio.hasIdentified) {
        const embeddedLendio = window.lendio.getIdentity()
        this.fastTrackUser = embeddedLendio.user.lendioUserId

        if (this.fastTrackUser) {
          this.showFastTrack = true;
        }
      } else {
        // If embedded dom app hasn't identified (successful lendio.initialize()) / failed to be called, let's give it a chance
        const cb = () => {
          this.checkEmbeddedUser(--attempts)
        }
        this._delay(ms).then(cb)
      }
    },
    triggerEmbeddedApplication (attempts = 5, ms = 500) {
      if (!attempts) return

      if (window.lendio && window.lendio.hasIdentified) {
        return window.lendio.launchLoanApplication()
      } else {
        // If embedded dom app hasn't identified (successful lendio.initialize()) / failed to be called, let's ensure it's resolved first before launching
        const cb = () => {
          this.triggerEmbeddedApplication(--attempts)
        }
        this._delay(ms).then(cb)
      }
    },
    launchEmbeddedApplication () {
      const embeddedOrganizationBody = useBorrowerStore(this.$pinia).getEmbeddedOrganization
      this.toggleFastTrackModalVisibility(false, this.isTestBorrower)
      if (window.lendio && this.canUseEmbedded && embeddedOrganizationBody) {
          if (!window.lendio.hasIdentified) {
            const embeddedInitBody = useRootStore(this.$pinia).getEmbeddedInitBody

            if (embeddedInitBody) {
              window.lendio.initialize({ ...embeddedInitBody, organization: embeddedOrganizationBody })
              this.triggerEmbeddedApplication()
            }
          } else {
            window.lendio.identifyOrganization(embeddedOrganizationBody)
            this.triggerEmbeddedApplication()
          }
      }
    },
    _delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
  },
  watch: {
    showFastTrack(val) {
      if (val && this.forceOpen) {
        this.launchEmbeddedApplication()
      }
    },
    forceFastTrackCTA(val) {
      if (val) {
        try {
          window.lendio.postUserEvent('fastTrackCtaSeen', {
              'user': this.authUser
          })
        }
        catch (error) {
          // Let it go like Elsa
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fast-track-cta-wrapper {
  max-width: 296px;
  background-color: #FFFFFF;
  border-radius: 16px;
  padding: 24px;
  margin: 60px auto 140px;
  text-align: left;
  transition:
    transform 400ms,
    opacity 400ms 100ms
    ease-in-out;

  .fast-track-cta-subheader {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #181818;
  }

  .fast-track-cta-bullet-list {
    padding: 0px 14px;
    margin-bottom: 6px;
    margin-left: 16px;

    .fast-track-cta-bullet-point {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #6B717A;
    }
  }

  .fast-track-btn-start {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 16px;
    width: 248px;

    .fast-track-btn-start-text {
      font-size: 16px;
    }
  }
}

.fast-track-mb-2 {
  margin-bottom: 8px;
}

.fast-track-hide {
  height: 0;
  transform: scaleY(0);
  opacity: 0;
  margin: 0;
  padding: 0;
  transition:
    transform 400ms,
    margin 0ms 400ms,
    padding 0ms 400ms,
    opacity 400ms 100ms
    ease-in-out;
}
</style>
